import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { completeSSOLogin, markActive, startSSOLogin } from "@/services/userLogin";

const SSO_ERRORS: Record<string, string> = {
  sso_failed: "Sign-in was cancelled or failed. Please try again.",
  wrong_tenant: "This account is not part of the organisation.",
  sso_no_identity: "Could not read your account details from the identity provider.",
  provisioning_failed: "Could not set up your account. Contact your administrator.",
  sso_no_tokens: "Sign-in did not complete. Please try again.",
  state_expired: "Your sign-in session expired. Please try again.",
  user_not_in_config: "This account hasn't been granted access to Prism. Please contact your administrator.",
  config_incomplete: "Your access configuration is incomplete. Please contact your administrator to set your grade.",
};


const RETRY_KEY = "sso_retry";

const SSOCallback = () => {
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    try {
      const user = completeSSOLogin();
      sessionStorage.removeItem(RETRY_KEY);
      window.location.hash = "";
      markActive();
      navigate(user.must_change_password ? "/setup-password" : "/dashboard", { replace: true });
    } catch (error) {
      const code = error instanceof Error ? error.message : "sso_failed";
      if (code === "state_expired" && !sessionStorage.getItem(RETRY_KEY)) {
        sessionStorage.setItem(RETRY_KEY, "1");
        startSSOLogin();
        return;
      }
      sessionStorage.removeItem(RETRY_KEY);
      const message = SSO_ERRORS[code] ?? SSO_ERRORS.sso_failed;
      navigate(`/?sso_error=${encodeURIComponent(message)}`, { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-dvh flex items-center justify-center px-4 text-center text-muted-foreground">
      Signing you in…
    </div>
  );
};

export default SSOCallback;
